import dayjs from 'dayjs';

type RawDate = string | number | Date | dayjs.Dayjs | null | undefined;
type Format = 'render' | 'datetime-local' | 'date' | 'time' | string;
function DateFormatTo(value?: RawDate, format_: Format = 'DD-MM-YYYY HH:mm') {
  if (!value) return '';
  if (typeof value === null) return '';
  if (value instanceof Date) value = dayjs(value);
  if (typeof value === 'number') value = new Date(value);
  if (typeof value === 'string') value = new Date(value);
  if (dayjs.isDayjs(value)) value = value.toDate();

  const d = dayjs(value);

  switch (format_) {
    case 'render':
      return d.format('DD.MM.YYYY HH:mm');
    case 'datetime-local':
      return d.format('YYYY-MM-DDTHH:mm');
    case 'date':
      return d.format('DD-MM-YYYY');
    case 'time':
      return d.format('HH:mm');
    default:
      return d.format(format_);
  }
}

export default DateFormatTo;
